import React from "react";
import { Fragment } from "react";
import HeaderHome from "../layout/HeaderHome";
import SliderHome from "../layout/SliderHome";
//import SliderAliados from "../layout/SliderAliados";
import FooterHome from "../layout/FooterHome";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import programasdeformacion from "../static/images/programas_de_formacion.svg";
import contenidorelevante from "../static/images/contenido_relevante.svg";
import comunidad from "../static/images/comunidad.svg";
import propioseventos from "../static/images/propios_eventos.svg";
import red from "../static/images/red.svg";
//import bgtestimonial from "../static/images/bg-testimonial.png";
//import bgtestimonial2 from "../static/images/bg-testimonial2.png";

//import model006 from "../static/images/model006.png";
import gear_wheel from "../static/images/gear-wheel.svg";

import model006 from "../static/images/Home/FOTO4.webp";

function Centro() {
  const images = [
    {
      url: model006,
      tittle: "Conecta, Enseña y Desarrolla",
      content: "El espacio para formar a las y los jóvenes del futuro",
    },
  ];

  return (
    <Fragment>
      <HeaderHome></HeaderHome>
      <section id="hero" className="hero centros">
        <img src={gear_wheel} alt="" className="hero__gear rotate"></img>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-10 px-0">
              <SliderHome images={images}></SliderHome>
            </div>
          </div>
        </div>
      </section>
      <section className="socios">
        <div className="container">
          <div className="row seven-cols">
            {/* <img
              src={empuje}
              alt="empuje"
              style={{ height: "250px", width: "400px" }}
            ></img>
            <div className="col">
              <a href="https://www.canada.ca/en.html">
                <img src={canada} alt="canada"></img>
              </a>
            </div>
            <div className="col ln-border">
              <a href="https://childrenbelieve.ca/">
                <img src={childre} alt="childre"></img>
              </a>
            </div>
            <div className="col text-right">
              <span className="title">SOCIOS</span>
            </div>
            <div className="col c-13">
              <a href="https://cep.empuje.org/">
                <img src={cep} alt="cep"></img>
              </a>
            </div>
            <div className="col c-13">
              <a href="https://www.heifer.org/">
                <img src={heifer} alt="heifer"></img>
              </a>
            </div>
            <div className="col c-13">
              <a href="https://www.tecnacional.edu.ni/">
                <img
                  src={inatec}
                  alt="inatec"
                  style={{ width: "130px", height: "85px" }}
                ></img>
              </a>
            </div>*/}
          </div>
        </div>
      </section>

      <section className="comunidad empresa">
        <div className="container">
          <div className="title">
            Creamos el espacio para que <span>enseñes lo que te apasiona.</span>
          </div>
          <div className="sub-title">
            Te conectamos con la juventud para desarrollar y construir un fuerza
            laboral competitiva que permita mejorar su calidad de vida.
          </div>

          <div className="sub-title" style={{ height: "auto" }}>
            Construimos un programa de reconocimiento basado en insignias y
            diplomas promoviendo una experiencia dinámica y transformadora
            facilitando el proceso de aprendizaje.
          </div>

          <div className="row justify-content-center mt-5">
            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={programasdeformacion} alt="formacion"></img>
                <h3>
                  Publica tus cursos, becas, <span>talleres, etc.</span>
                </h3>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={contenidorelevante} alt=""></img>
                <h3>
                  Desarrolla y comparte <span>contenido relevante</span>
                </h3>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={comunidad} alt=""></img>
                <h3>
                  Forma grupos de interés e <span>interactúa con tu</span>{" "}
                  comunidad
                </h3>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={propioseventos} alt=""></img>
                <h3>Crea tus propios eventos</h3>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={red} alt=""></img>
                <h3>
                  Establece una comunicación <span>directa con tu red.</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*
      <section className="casos-estudios">
        <div className="container">
          <div className="title">Caso de Estudio</div>
          <div className="row">
            <div className="col-md-12">
              <div id="testimonial-slider-2">
                <div
                  id="carouselExampleControls"
                  className="carousel slide"
                  data-bs-ride="carousel"
                  data-bs-interval="5000"
                  data-bs-touch="true"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="testimonials">
                        <div className="testimonial-content">                         
                          <div className="description">
                            <p>
                              ...
                            </p>
                            <p>
                              ..
                            </p>

                            <h3 className="testimonial-title">Roberto Gomez</h3>
                          </div>
                        </div>
                        <div className="pic">
                          <img src={bgtestimonial} alt=""></img>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="testimonials">
                        <div className="testimonial-content">
                          
                          <div className="description">
                            <p>
                              ...
                            </p>
                            <p>
                            ...
                            </p>

                            <h3 className="testimonial-title">Roberto Gomez</h3>
                          </div>
                        </div>
                        <div className="pic">
                          <img src={bgtestimonial2} alt=""></img>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}
      {/*
      <section className="aliados empresa">
        <div className="container">
          <div className="title">Nuestros Aliados</div>
          <div className="row">
            <SliderAliados></SliderAliados>
          </div>
        </div>
      </section>
    */}
      <section className="news">
        {/*<div className="title">Últimas Publicaciones</div>
        <div className="container" >      
        <div className="row">                   
          <div className="leerMas">                       
              <a href="https://cep.empuje.org/blog/" target="_blank"  > Leer Mas</a>
          </div>
        </div>
        </div>
       
        <div className="container">
          <div className="title">Últimas publicaciones</div>
          <div className="row">
            <div className="col-sm-4">
              <img src={blog1}></img>
              <span>10 de Octubre, 2020</span>
              <h2>Guía para preparar una Entrevista de Trabajo</h2>
              <p>
                Prepara tu próxima entrevista, utiliza nuestra guía e informate
                de qué preguntas te pueden hacer y cómo responderlas, qué no
                debes decir, cómo explicar tus áreas a mejorar, qué preguntas
                puedes hacer, entre otros.
              </p>
              <a href="#">Leer más</a>
            </div>

            <div className="col-sm-4">
              <img src={blog2} alt=""></img>
              <span>09 de Octubre, 2020</span>
              <h2>
                Lista de control de <span>diversidad e inclusión</span>
              </h2>
              <p>
                La diversidad y la inclusión se mencionan a menudo en la misma
                frase, porque una organización inclusiva no puede existir sin
                uan fuerza de trabajo diversa. Y una organización debe ser
                inclusiva a fin de mantener su personal diverso.
              </p>
              <a href="#">Leer más</a>
            </div>

            <div className="col-sm-4">
              <img src={blog3} alt=""></img>
              <span>12 de Octubre, 2020</span>
              <h2>Diseña tu plan de carrera</h2>
              <p>
                El plan de carrera es una estrategia empresarial para conseguir
                talento valioso para las compañias. Te damos a conocer los
                secretos de esta táctica para poder ponerla en práctica.
              </p>
              <a href="#">Leer más</a>
            </div>
          </div>/
        </div>/*/}
      </section>

      <FooterHome></FooterHome>
    </Fragment>
  );
}

export default Centro;
